<template lang="html">
  <div id="searching-vet" class="row">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9 searching-vet-container">
      <div class="row searching-vet-background">
        <form @submit.prevent="searchDoctorForm" novalidate>
          <div class="row">
            <div class="text-left col-sm-12 header-searching"><h3>{{translation.doctor.searchDoctorHeaderCriteria}}</h3></div>
            <p v-if="errors.length" class="text-center text-danger col-sm-12">
              <ul class="list-group">
                <li class="text-danger text-center list-group-item list-group-item-light" v-for="error in errors">{{ error }}</li>
              </ul>
            </p>
            <div class="col-sm-12">
              <div class="row  search-vet-button-container">
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="email" class="form-control" name="doctor-search-email" v-model="doctorSearch.email" :placeholder="translation.registration.email">
                    <label for="doctor-search-email">{{translation.registration.email}}</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <input type="text" class="form-control" name="doctor-search-clinic" v-model="doctorSearch.clinic" :placeholder="translation.registration.clinic">
                    <label for="doctor-search-clinic">{{translation.registration.clinic}}</label>
                  </div>
                </div>
                <div class="col-md-4 search-vet-button">
                  <button type="submit" class=""><span><img src="../../assets/img/icons/search-vet.svg"/> </span>{{translation.button.search}}</button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-4">
                        <span class="search-names">{{translation.updateProfile.country}}:</span>
                      </div>
                      <div class="col-md-8">
                        <select v-model="doctorSearch.country" @change="countrySelected">
                          <option v-for="country in clinicsCountry" :value="country.doctorCountry">{{country.doctorCountry}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-4">
                        <span class="search-names">{{translation.updateProfile.city}}:</span>
                      </div>
                      <div class="col-md-8">
                        <select v-model="doctorSearch.city" :disabled='cityBolean'  @change="citySelected">
                          <option v-for="city in clinicsCity" :value="city.doctorCity">{{city.doctorCity}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <div class="row">
                      <div class="col-md-4">
                        <span class="search-names">{{translation.updateProfile.neighborhood}}:</span>
                      </div>
                      <div class="col-md-8">
                        <select v-model="doctorSearch.neighborhood" :disabled='neighborhoodBolean'>
                          <option v-for="neighborhood in clinicsNeighborhood" :value="neighborhood.doctorNeighborhood">{{neighborhood.doctorNeighborhood}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="row doctor-search-result">
        <div class="col-sm-12" v-if="noResult">
          <h3>{{translation.doctor.noResult}}</h3>
        </div>
        <div class="col-sm-12 text-success" v-if="succesAddDoctor">
          <h3>{{translation.doctor.successAdd}} <span class="text-success">{{translation.petReview.addByDoctor + doctorName}}</span>{{translation.doctor.inFav}}</h3>
        </div>
        <div class="col-sm-12 text-danger" v-else-if="thisVetIsAdded">
          <h3><span class="text-success">{{translation.petReview.addByDoctor + doctorName}}</span>{{translation.doctor.addedVet}}</h3>
        </div>
        <div class="col-sm-12" v-if='doctors.length'>
          <div class="row">
            <div class="col-md-4" v-for="(doctor,idx) in doctors">
              <div class="row doctor-card" :id="doctor.doctorId"  @click="toggle(doctor,idx)">
                <div class="col-md-5" >
                  <span class="doctorThumb" v-if="doctor.doctorThumb">
                    <img class="img-circle img-fluid img-responsive" v-bind:src="doctor.doctorThumb" :alt="translation.profile.altImage +doctor.doctorFirstName">
                  </span>
                  <span class="doctorThumb" v-else>
                    <img class="img-circle img-fluid img-responsive" src="../../assets/img/icons/vet-icon.svg" alt="Default Image">
                  </span>
                </div>
                <div class="col-md-7">
                  <div class="doctorName">
                    {{translation.petReview.addByDoctor + ' ' + doctor.doctorFirstName + translation.profile.space  + doctor.doctorLastName}}
                  </div>
                  <div v-show="isSelected == idx && isSelected != null" class="add-favorite-doctor" @click='favorite(doctor.doctorId,doctor.doctorFirstName,doctor.doctorLastName)'>
                    <img src="../../assets/img/icons/add-to-favorite-doctors.svg" alt="Favorite Doctor">
                  </div>
                  <div class="add-favorite-text">
                    {{translation.button.addFavoriteDoctor}}
                  </div>
                </div>
                <div class="col-sm-12 doctor-other-info" v-show="isSelected == idx && isSelected != null" >
                  <div class="row">
                    <div class="doctorAdress">
                      <span v-if="doctor.doctorCountry && doctor.doctorCountry != 'null'"><span>{{translation.profile.address}}: </span>{{doctor.doctorCountry}}</span> <span v-if="doctor.doctorCity && doctor.doctorCity != 'null'">, {{doctor.doctorCity}}</span><span v-if="doctor.doctorNeighborhood && doctor.doctorNeighborhood != 'null'">, {{doctor.doctorNeighborhood}}</span>
                    </div>
                    <div>
                      <span v-if="doctor.clinicName"><span>{{translation.registration.clinic}}: </span>{{doctor.clinicName}}</span>
                    </div>
                    <div>
                      <span v-if="doctor.doctorEmail"><span>{{translation.registration.email}}: </span>{{doctor.doctorEmail}}</span>
                    </div>
                    <div>
                      <span v-if="doctor.doctorPhone"><span>{{translation.registration.phoneNumber}}: </span>{{doctor.doctorPhone}}</span>
                    </div>
                    <div class="text-dots">
                      <span v-if="doctor.clinicWebsite">
                        <a :href="doctor.clinicWebsite" target="_blank"><span>{{translation.registration.website}}: </span>{{doctor.clinicWebsite}}</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      translation: null,
      errors: [],
      doctors: [],
      names: null,
      succesAddDoctor: false,
      thisVetIsAdded: false,
      loader: false,
      noResult: false,
      isSelected: false,
      cityBolean: true,
      neighborhoodBolean: true,
      doctorName: '',
      clinicsCountry: [],
      clinicsCity: [],
      clinicsNeighborhood: [],
      doctorSearch:{
        email: '',
        clinic: '',
        country: '',
        city: '',
        neighborhood:''
      }
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    var self = this;
    axios.get('search-vets-page')
    .then(function(response){
      self.noResult = false;
      self.clinicsCountry = response.data.result;
    })
    .catch(err => err)
    this.translation = window.message;
    window.pageHeader = this.translation.doctor.searchDoctorHeader;
  },
  methods: {
    validate: function (e) {
      this.errors = [];
      if (!this.doctorSearch.email && !this.doctorSearch.clinic
      && !this.doctorSearch.country && !this.doctorSearch.city && !this.doctorSearch.neighborhood) {
            this.errors.push(
              this.translation.errors.doctorSearchError
            )
      }

      if (!this.errors.length) {
        return true;
      }
    },
    countrySelected: function(e){
      var self = this;
      var formData = this.toFormData({country:this.doctorSearch.country})
      axios.post('search-vets-country',formData)
      .then(function(response){
        self.noResult = false;
        self.clinicsCity = response.data.result;
      })
      .catch(err => err)
      this.cityBolean = false;
    },
    citySelected: function(e){
      var self = this;
      var formData = this.toFormData({city:this.doctorSearch.city})
      axios.post('search-vets-city',formData)
      .then(function(response){
        self.noResult = false;
        self.clinicsNeighborhood = response.data.result;
      })
      .catch(err => err)
      this.neighborhoodBolean = false;
    },
    searchDoctorForm: function (e){
      if (this.validate(e)) {
        this.loader = true;
        this.doctors = [];
        var formData = this.toFormData(this.doctorSearch);
        var self = this;
        axios.post('search-doctors', formData)
        .then(function(response){
          self.loader = false;
          if (response.data.result.noResult) {
            self.noResult = response.data.result.noResult;
            self.showOwnerInformation  = false;
          }else {
            self.noResult = false;
            self.doctors = response.data.result;
          }
        })
        .catch(err => err)
      }
    },
    favorite: function(id,name,last){
      this.loader = true;
      var formData = this.toFormData({doctorId: id});
      var self = this;
      axios.post('add-favorite-doctor', formData)
      .then(function(response){
        self.loader = false;
        self.thisVetIsAdded = false;
        self.doctorName = name +' '+last;
        self.succesAddDoctor = true;
        if (response.data.result.serverMessage) {
          self.thisVetIsAdded = true;
          self.succesAddDoctor = false;
        }
      })
      .catch(err => err)
    },
    toggle(review,idx) {
      if(this.isSelected != idx){
        this.isSelected = idx;
      }else{
      	this.isSelected = null
      }
    },
    toFormData: function (obj){
      var form_data = new FormData();
      for (var key in obj) {
        form_data.append(key,obj[key]);
      }
      return form_data;
    }
  }
}
</script>

<style>
#app #searching-vet  {
  background-image: url('../../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
}
 .searching-vet-container{
  margin-top: 9em;
  margin-bottom: 9em;
}
.searching-vet-background{
  background: #FE7154;
  padding: 2em;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-radius: .75em;
}
.doctorName {
  margin-top: 4em;
  margin-bottom: 2em;
  color: #3057B0;
  font-weight: bold;
}
.doctor-other-info{
  margin-top: 2em;
  background: #3057B0;
  padding: 1em;
  color: #fff;
  text-align: center;
  border-bottom-left-radius: .75em;
  border-bottom-right-radius: .75em;
}
#searching-vet .doctor-other-info div{
    word-wrap: break-word;
}
#searching-vet  .text-dots span,
#searching-vet  .text-dots a{
  display: block;
}
.doctor-other-info a{
  color: #fff;
}
.doctor-search-result .doctor-card{
  background: #fff;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-radius: .75em;
  position: relative;
  margin-bottom: 1em;
}
#searching-vet .add-favorite-doctor{
  position: absolute;
  top: 1.4em;
  right: 1em;
  background: transparent;
  border: none;
  z-index: 2;
}
.add-favorite-doctor:hover{
  cursor: pointer;
}
.add-favorite-text{
  display: none;
}
.add-favorite-doctor:hover + .add-favorite-text{
  background: rgba(0, 0, 0, 0.5);
  border-radius: 1em;
  padding-left: .5em;
  padding-right: .5em;
  color: #fff;
  display: block;
  position: absolute;
  right: 0;
  top: 3.3em;
  z-index: 2;
}
.doctor-search-result{
  margin-top: 2em;
}
.doctor-search-result .doctorThumb img{
  margin-top: 1em;
  margin-bottom: 1em;
  border: 3px solid #3057B0;
}
#searching-vet .header-searching h3{
  color: #fff;
  text-align: left;
}
.search-vet-button-container{
  position: relative;
}
.search-vet-button{
  position: absolute;
  bottom: 0;
  right: 0;
}
.search-vet-button button{
  background: #fff;
  border: none;
  padding: .5em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 5em;
  color: #3057B0;
  font-weight: bold;
}
.form-group{
  position: relative;
  margin-top: 2em;
}
 #searching-vet input[type=text],
 #searching-vet input[type=password],
 #searching-vet input[type=email],
 #searching-vet select
{
 color: #fff!important;
 background: none!important;
 border: none!important;
 border-radius: 0!important;
 outline: none!important;
 border-bottom: 2px solid #fff!important;
 width: 100%;
 outline: none!important;
 box-shadow: none;
}
 #searching-vet label {
 display: none;
}
 #searching-vet input[type=text]:focus,
 #searching-vet input[type=password]:focus,
 #searching-vet input[type=email]:focus,
 #searching-vet select:focus
{
 border-bottom: 2px solid #3057B0!important;
 outline:0px !important;
 -webkit-appearance:none;
 box-shadow: none !important;
}
.search-names{
  color: #fff!important;
  font-size: 1em;
}
#searching-vet option{
  color: #000;
}
 #searching-vet input[type=text]:focus + label ,
 #searching-vet input[type=password]:focus + label,
 #searching-vet input[type=email]:focus + label,
 #searching-vet select:focus + label
{
  display: block;
  position: absolute;
  bottom: 2em;
  color: #fff!important;
  font-size: 1em;
  opacity: 1;
}
#searching-vet ::placeholder,
#searching-vet select::placeholder {
  color: #fff;
  opacity: 1;
}
#searching-vet :-ms-input-placeholder,
#searching-vet select:-ms-input-placeholder {
  color: #fff;
  opacity: 1;
}
#searching-vet ::-ms-input-placeholder,
#searching-vet select::-ms-input-placeholder {
  color: #fff;
  opacity: 1;
}
 #searching-vet input[type=text]:focus::-webkit-input-placeholder,
 #searching-vet input[type=password]:focus::-webkit-input-placeholder,
 #searching-vet input[type=email]:focus::-webkit-input-placeholder,
 #searching-vet select:focus::-webkit-input-placeholder
{
 color:transparent!important;
}
 #searching-vet input[type=text]:focus::-moz-placeholder
 #searching-vet input[type=password]:focus::-moz-placeholder
 #searching-vet input[type=email]:focus::-moz-placeholder,
 #searching-vet select:focus::-moz-placeholder {
 color:transparent!important;
}
 #searching-vet input[type=text]:focus::-moz-placeholder
 #searching-vet input[type=password]:focus::-moz-placeholder
 #searching-vet input[type=email]:focus::-moz-placeholder,
 #searching-vet select:focus::-moz-placeholder {
  color:transparent!important;
}
 #searching-vet input[type=text]:focus::-ms-input-placeholder
 #searching-vet input[type=password]:focus::-ms-input-placeholder
 #searching-vet input[type=email]:focus::-ms-input-placeholder,
 #searching-vet select:focus::-ms-input-placeholder {
 color:transparent!important;
}
.list-group-item{
 border: none;
 background: none;
 padding-left: 0;
 font-size: 1em;
}
@media (max-width:991px) {
  .doctor-search-result .doctorThumb img{
    width: 7em;
    height: 7em;
    border: 3px solid #3057B0;
  }
}
</style>
